module.exports = __webpack_public_path__ + "img/431d121.svg";